import {
  config
} from '../_config'
import {
  authHeader,
  handleResponse
} from '../_helpers'

export const inscriptionsService = {
  srvInscriptionsAll
};

function srvInscriptionsAll() {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/adminInscriptions`, requestOptions)
    .then(handleResponse);


}
